var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeizol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 57,
    viewBox: "0 0 47 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69995 40.36C1.69995 33.36 12.51 15.19 15.78 9.85001C16.1 9.34001 16.77 9.18001 17.28 9.50001C17.42 9.59001 17.54 9.71001 17.63 9.85001C20.91 15.19 31.71 33.33 31.71 40.36C31.71 48.64 24.99 55.36 16.71 55.36C8.42995 55.36 1.70995 48.64 1.70995 40.36H1.69995Z",
    stroke: "#4C4B4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.85 44.6C23.1 47.64 19.85 49.51 16.34 49.51M31.51 15.26C31.51 11.99 36.51 3.57001 38.05 1.09001C38.2 0.850007 38.52 0.780007 38.75 0.930007C38.81 0.970007 38.87 1.02001 38.91 1.09001C40.43 3.57001 45.45 12 45.45 15.26C45.09 19.11 41.68 21.94 37.83 21.58C34.48 21.27 31.82 18.61 31.51 15.26Z",
    stroke: "#4C4B4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeizol);
export default __webpack_public_path__ + "static/media/IconHeizol.72b506b1b04718d32b7bcf6554640848.svg";
export { ForwardRef as ReactComponent };